import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'Exportar Arquivo da 2ª Etapa (Situação Final)',
    path: '/censoescolar/situacaofinal',
    name: 'censo_exportar_etapa2',
    component: () => import('@/views/censoescolar/situacaofinal/Index.vue'),
    meta: {
      isLegacy: false,
      // [CENSO] Mesma permissão da tela de pendências da etapa (decisão do Arthur, 30/10/2026): quem vê as
      //   pendências exporta o arquivo — as rotas CensoArquivo/{etapa}/Previa e /Download estão ligadas a ela (sql/003).
      permissions: [eTipoPermissao.PENDENCIAS_CENSO_SF_NOVO_300800520],
    },
    goesToMenu: true,
  },
  {
    // [CENSO] Painel de pendências do Censo (API acadêmica). Path próprio: antes dividia o
    // path da exportação e apontava para um stub vazio. O NOME da rota foi mantido (Seg_Menu).
    description: 'Pendências do Censo - 2ª Etapa (Situação Final)',
    path: '/censoescolar/situacaofinal/pendencias',
    name: 'censo_rel_pendencias_etapa2',
    component: () => import('@/views/censoescolar/pendencias/PendenciasCenso.vue'),
    props: { etapa: 2 },
    meta: {
      isLegacy: false,
      permissions: [eTipoPermissao.PENDENCIAS_CENSO_SF_NOVO_300800520],
    },
    goesToMenu: true,
  },
];
